// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "domain/ymere-verhuisregelingen-nl/css/web-" + "components" + ".css";
};